import React, { useEffect, useState, useRef } from "react";
import "./ClipboardImageLibrary.css";

export default function ClipboardImageLibrary() {
    const [images, setImages] = useState(() => {
        try {
            const raw = localStorage.getItem("cw_image_library");
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    });

    const [pages, setPages] = useState(() => {
        try {
            const raw = localStorage.getItem("cw_image_pages");
            return raw ? JSON.parse(raw) : {};
        } catch {
            return {};
        }
    });

    const [currentPage, setCurrentPage] = useState("library");
    const [filter, setFilter] = useState("");
    const [filterPossede, setFilterPossede] = useState("all");
    const [modal, setModal] = useState({ open: false, url: null });
    const [lastText, setLastText] = useState("");
    const intervalRef = useRef(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [titles, setTitles] = useState({});

    const menuRef = useRef(null);
    const [selectedImages, setSelectedImages] = useState([]);
    const [moveMenuOpen, setMoveMenuOpen] = useState(false);


    const [currentBibliotheque, setCurrentBibliotheque] = useState(null); // bibliothèque ouverte
    const [bibliotheques, setBibliotheques] = useState(() => {
        try {
            const raw = localStorage.getItem("bibliotheques");
            return raw ? JSON.parse(raw) : {};
        } catch {
            return {};
        }
    });


    const [openLibraries, setOpenLibraries] = useState(() => {
        try {
            const saved = localStorage.getItem("open_libraries");
            return saved ? JSON.parse(saved) : {};
        } catch {
            return {};
        }
    });


    useEffect(() => {
        const noms = Object.keys(bibliotheques);
        if (noms.length > 0 && !currentBibliotheque) {
            setCurrentBibliotheque(noms[0]); // ouvre automatiquement la première bibliothèque
        }
    }, [bibliotheques]);


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest(".dropdown-panel") && !e.target.closest("button")) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    useEffect(() => {
        fetch("http://127.0.0.1:5001/get_titles")
            .then(res => res.json())
            .then(setTitles)
            .catch(console.error);
    }, []);



    useEffect(() => {
        fetch("https://slimjah.fr/bibliotheques/bibliotheque.json")
            .then(res => res.json())
            .then(data => {
                setImages(data.images || []);
                setPages(data.pages || {});
            })
            .catch(err => console.error("Erreur de chargement FTP :", err));
    }, []);


    const saveTitles = (file, title) => {
        fetch("http://127.0.0.1:5001/save_title", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ file, title }),
        })
            .then(res => res.json())
            .then(data => console.log("✅ Titre sauvegardé :", data))
            .catch(err => console.error("Erreur sauvegarde:", err));
    };

    useEffect(() => {
        Promise.all([
            fetch("/images/images-list.json").then(res => res.json()),
            fetch("/titles.json").then(res => res.json())
        ])
            .then(([files, titles]) => {
                const imgsFromJson = files.map((filename) => ({
                    id: Date.now() + Math.random(),
                    title: titles[filename] || filename,
                    path: `/images/${filename}`,
                    possede: false,
                    editingTitle: false,
                    addedAt: new Date().toISOString(),
                }));

                setImages((prevImages) => {
                    const pathsInPages = Object.values(pages).flat().map((i) => i.path);
                    const pathsInLibrary = prevImages.map((i) => i.path);
                    const newImgs = imgsFromJson.filter(
                        (img) =>
                            !pathsInLibrary.includes(img.path) &&
                            !pathsInPages.includes(img.path)
                    );
                    return [...prevImages, ...newImgs];
                });
            })
            .catch((err) => console.error("⚠️ Erreur chargement images/titres :", err));
    }, [pages]);

    useEffect(() => {
        localStorage.setItem("cw_image_library", JSON.stringify(images));
    }, [images]);

    useEffect(() => {
        localStorage.setItem("cw_image_pages", JSON.stringify(pages));
    }, [pages]);


    const toggleLibraryOpen = (nomBibliotheque) => {
        setOpenLibraries(prev => {
            const updated = {
                ...prev,
                [nomBibliotheque]: !prev[nomBibliotheque],
            };
            localStorage.setItem("open_libraries", JSON.stringify(updated));
            return updated;
        });
    };



    const manualPaste = async () => {
        try {
            const text = await navigator.clipboard.readText();
            setLastText(text);
            if (!tryAddUrl(text)) alert("Aucune URL d'image trouvée.");
        } catch {
            alert("Impossible de lire le presse-papiers.");
        }
    };

    const tryAddUrl = (text) => {
        if (!text) return null;
        const trimmed = text.trim();
        if (trimmed.startsWith("http")) {
            addImage(trimmed);
            return trimmed;
        }
        return null;
    };

    const addImage = async (url) => {
        try {
            const res = await fetch("http://127.0.0.1:5001/save_image", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ url }),
            });

            if (!res.ok) throw new Error("Erreur backend save_image");
            const data = await res.json();

            const newImg = {
                // id: String(Date.now() + Math.random()), // <-- important
                id: String(Date.now() + Math.random()),

                title: data.filename || url.split("/").pop().split("?")[0],
                path: data.path.startsWith("/images/")
                    ? data.path
                    : `/images/${data.filename || data.path.split("/").pop()}`,
                addedAt: new Date().toISOString(),
                possede: false,
                editingTitle: false,
            };


            if (currentPage === "library") {
                setImages((prev) =>
                    prev.find((p) => p.path === newImg.path) ? prev : [newImg, ...prev]
                );
            } else {
                setPages((prev) => ({
                    ...prev,
                    [currentPage]: prev[currentPage]
                        ? [newImg, ...prev[currentPage]]
                        : [newImg],
                }));
            }
        } catch (err) {
            console.error("Erreur ajout image:", err);
            alert("Impossible d’ajouter l’image: " + err.message);
        }
    };

    const removeImage = (id, pageName = null) => {
        if (pageName) {
            setPages((prev) => ({
                ...prev,
                [pageName]: prev[pageName].filter((i) => i.id !== id),
            }));
        } else {
            setImages((prev) => prev.filter((i) => i.id !== id));
        }
    };

    const moveImageToPage = (img, pageName) => {
        if (!pageName) return;

        setPages((prevPages) => {
            const newPages = {
                ...prevPages,
                [pageName]: [...(prevPages[pageName] || []), img],
            };
            return newPages;
        });

        setImages((prevImages) => prevImages.filter((i) => i.id !== img.id));

        if (currentPage !== "library") {
            setPages((prevPages) => ({
                ...prevPages,
                [currentPage]: (prevPages[currentPage] || []).filter(
                    (i) => i.id !== img.id
                ),
            }));
        }
    };

    const toggleEditing = (imgId, editing) => {
        if (currentPage === "library") {
            setImages((prev) =>
                prev.map((i) => (i.id === imgId ? { ...i, editingTitle: editing } : i))
            );
        } else {
            setPages((prev) => ({
                ...prev,
                [currentPage]: prev[currentPage].map((i) =>
                    i.id === imgId ? { ...i, editingTitle: editing } : i
                ),
            }));
        }
    };

    const togglePossede = (imgId) => {
        if (currentPage === "library") {
            setImages((prev) =>
                prev.map((i) => (i.id === imgId ? { ...i, possede: !i.possede } : i))
            );
        } else {
            setPages((prev) => ({
                ...prev,
                [currentPage]: prev[currentPage].map((i) =>
                    i.id === imgId ? { ...i, possede: !i.possede } : i
                ),
            }));
        }
    };

    const updateTitle = (imgId, newTitle) => {
        if (currentPage === "library") {
            setImages((prev) =>
                prev.map((i) => (i.id === imgId ? { ...i, title: newTitle } : i))
            );
        } else {
            setPages((prev) => ({
                ...prev,
                [currentPage]: prev[currentPage].map((i) =>
                    i.id === imgId ? { ...i, title: newTitle } : i
                ),
            }));
        }
    };

    const getCurrentImages = () => {
        const all = currentPage === "library" ? images : pages[currentPage] || [];
        return all
            .filter((i) => {
                const f = filter.toLowerCase();
                return (
                    !f ||
                    (i.title && i.title.toLowerCase().includes(f)) ||
                    (i.path && i.path.toLowerCase().includes(f))
                );
            })
            .filter((i) => {
                if (filterPossede === "yes") return i.possede;
                if (filterPossede === "no") return !i.possede;
                return true;
            })
            .sort((a, b) => (a.title || "").localeCompare(b.title || ""));
    };

    const createPage = () => {
        const name = prompt("Nom de la nouvelle sous-bibliothèque :");
        if (!name || pages[name]) return;
        setPages((prev) => ({ ...prev, [name]: [] }));
        setCurrentPage(name);
    };

    const deletePage = (name) => {
        if (window.confirm(`Supprimer la page "${name}" ?`)) {
            setPages((prev) => {
                const copy = { ...prev };
                delete copy[name];
                return copy;
            });
            setCurrentPage("library");
        }
    };

    const downloadImage = (path) => {
        const a = document.createElement("a");
        a.href = path;
        a.download = path.split("/").pop() || "image";
        document.body.appendChild(a);
        a.click();
        a.remove();
    };


 

    const saveAllTitles = () => {
        const allTitles = {
        };


        // 1️⃣ Ajoute tous les titres de la bibliothèque principale
        images.forEach(img => {
            allTitles[img.path.split("/").pop()] = img.title || "";
        });

        // 2️⃣ Ajoute tous les titres des sous-pages
        Object.keys(pages).forEach(page => {
            pages[page].forEach(img => {
                allTitles[img.path.split("/").pop()] = img.title || "";
            });
        });

        // 3️⃣ Envoie tout au backend pour mettre à jour titles.json
        fetch("http://127.0.0.1:5001/save_all_titles", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(allTitles),
        })
            .then(res => {
                if (!res.ok) throw new Error("Erreur de sauvegarde de tous les titres");
                console.log("✅ Tous les titres ont été sauvegardés !");
                alert("✅ Tous les titres ont été enregistrés dans titles.json !");
            })
            .catch(err => console.error("Erreur lors de la sauvegarde globale :", err));
    };


    // 🧠 Filtrage par recherche + page courante
    // 🧩 Sélection des images de la page actuelle
    const currentImages =
        currentPage === "library"
            ? images
            : pages[currentPage] || [];

    // 🔍 Application du filtre texte + possédé
    const filtered = currentImages
        .filter((i) => {
            const f = filter.toLowerCase();
            return (
                !f ||
                (i.title && i.title.toLowerCase().includes(f)) ||
                (i.path && i.path.toLowerCase().includes(f))
            );
        })
        .filter((i) => {
            if (filterPossede === "yes") return i.possede;
            if (filterPossede === "no") return !i.possede;
            return true;
        });





     // Fournir le tableau affiché en fonction de la page + filtre
  const base = currentPage === "library" ? images : pages[currentPage] || [];
  const displayedImages = (() => {
    switch (filter) {
      case "possede": return base.filter(i => !!i.possede);
      case "nonpossede": return base.filter(i => !i.possede);
      default: return base;
    }
    })();


    const toggleSelect = (id) => {
        const idStr = String(id);
        setSelectedImages(prev =>
            prev.includes(idStr) ? prev.filter(i => i !== idStr) : [...prev, idStr]
        );
    };



    const selectAll = () => {
        const allIds = images.map((img) => String(img.id));
        setSelectedImages(allIds);
    };


    // Désélectionner toutes les images
    const deselectAll = () => {
        setSelectedImages([]);
    };


    const moveSelected = (targetPage) => {
        if (selectedImages.length === 0) return alert("Aucune image sélectionnée !");

        const selectedObjs = images.filter(img => selectedImages.includes(String(img.id)));
        const remaining = images.filter(img => !selectedImages.includes(String(img.id)));

        setPages(prev => ({
            ...prev,
            [targetPage]: [...(prev[targetPage] || []), ...selectedObjs],
        }));

        setImages(remaining);
        setSelectedImages([]);
    };

     
    const deleteSelected = () => {
        if (selectedImages.length === 0) return;
        if (!window.confirm(`Supprimer ${selectedImages.length} image(s) ?`)) return;
        const sel = new Set(selectedImages);
        setImages((prev) => prev.filter((img) => !sel.has(String(img.id))));
        deselectAll();
    };

    useEffect(() => {
        localStorage.setItem("cw_image_library", JSON.stringify(images));
    }, [images]);

    const isSelected = (id) => selectedImages.includes(String(id));


    // eslint-disable-next-line no-unused-vars
    const exportToJSON = () => {
        const data = { images, pages };
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "bibliotheque.json";
        a.click();
    };


    const creerBibliotheque = (nom) => {
        if (!nom) return;
        if (bibliotheques[nom]) return alert("Cette bibliothèque existe déjà !");
        const nouvelles = { ...bibliotheques, [nom]: [] };
        setBibliotheques(nouvelles); // ⚡ met à jour l'état pour réafficher
        localStorage.setItem("bibliotheques", JSON.stringify(nouvelles));
        alert(`Bibliothèque "${nom}" créée !`);
        setCurrentBibliotheque(nom); // ✅ active la nouvelle bibliothèque
    };


    const supprimerBibliotheque = (nom) => {
        if (window.confirm(`Supprimer la bibliothèque "${nom}" ?`)) {
            const nouvelles = { ...bibliotheques };
            delete nouvelles[nom];
            setBibliotheques(nouvelles);
            localStorage.setItem("bibliotheques", JSON.stringify(nouvelles));
            if (currentBibliotheque === nom) setCurrentBibliotheque(null);
        }
    };


    const moveSelectedToBibliotheque = (nomBibliotheque) => {
        if (!nomBibliotheque) return alert("Choisissez une bibliothèque !");
        if (selectedImages.length === 0) return alert("Aucune image sélectionnée !");

        // 🔍 Récupération des images sélectionnées (de la page actuelle)
        const currentImagesArray =
            currentPage === "library"
                ? images
                : pages[currentPage] || [];

        const selectedObjs = currentImagesArray.filter(img =>
            selectedImages.includes(String(img.id))
        );

        if (selectedObjs.length === 0) return alert("Aucune image sélectionnée valide !");

        // 🔁 Ajout des images dans la bibliothèque choisie
        const nouvelles = {
            ...bibliotheques,
            [nomBibliotheque]: [
                ...(bibliotheques[nomBibliotheque] || []),
                ...selectedObjs,
            ],
        };

        setBibliotheques(nouvelles);
        localStorage.setItem("bibliotheques", JSON.stringify(nouvelles));

        // ❌ Suppression des images déplacées de leur source
        if (currentPage === "library") {
            setImages((prev) =>
                prev.filter((img) => !selectedImages.includes(String(img.id)))
            );
        } else {
            setPages((prev) => ({
                ...prev,
                [currentPage]: prev[currentPage].filter(
                    (img) => !selectedImages.includes(String(img.id))
                ),
            }));
        }

        // ✅ Réinitialise la sélection
        setSelectedImages([]);

        alert(`✅ ${selectedObjs.length} image(s) déplacée(s) vers "${nomBibliotheque}"`);
    };


        



    return (
        <div className="p-4 max-w-7xl mx-auto font-sans">
            {/* HEADER */}
            <header className="flex items-center justify-between mb-4">
                <h1 className="text-2xl font-bold text-cyan-500">Bibliothèque d'images 2025</h1>
                <div className="flex gap-2">
                    <button onClick={manualPaste} className="glow">Coller</button>
                    <button onClick={createPage} className="px-3 py-1 rounded bg-green-500 text-white font-semibold">+ Nouvelle page</button>
                    <button onClick={() => { const nom = prompt("Nom de votre bibliothèque :"); if (nom) creerBibliotheque(nom); }}>Créer ma bibliothèque</button>
                </div>
            </header>

            {currentBibliotheque && (
                <div className="mb-4">
                    <h3 className="text-lg font-bold text-cyan-400">
                        {currentBibliotheque} ({bibliotheques[currentBibliotheque].length} images)
                    </h3>
                    

                   


                    <div className="p-4">
                        {Object.keys(bibliotheques).length === 0 ? (
                            <div className="text-gray-400 text-center p-6">
                                Aucune bibliothèque disponible
                            </div>
                        ) : (
                            Object.keys(bibliotheques).map((nom) => (
                                <section
                                    key={nom}
                                    className="mb-4 border border-gray-700 rounded-xl overflow-hidden"
                                >
                                    {/* 🧭 En-tête cliquable */}
                                    <div
                                        className="flex justify-between items-center px-4 py-2 bg-gray-800 cursor-pointer hover:bg-gray-700 transition"
                                        onClick={() => toggleLibraryOpen(nom)}
                                    >
                                        <h2 className="text-cyan-400 font-bold">{nom}</h2>
                                        <div className="flex items-center gap-2">

                                            {/* 🗑 Bouton supprimer bibliothèque */}
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    supprimerBibliotheque(nom);
                                                }}
                                                className="text-red-400 hover:text-red-600 text-xs border border-red-500 rounded-full p-1 hover:bg-red-900/40 transition flex items-center justify-center w-6 h-6"
                                                title="Supprimer cette bibliothèque"
                                            >
                                                🗑
                                            </button>



                                            <span className="text-gray-400">
                                                {openLibraries[nom] ? "▼" : "▶"}
                                            </span>
                                        </div>
                                    </div>

                                    {/* 🖼 Contenu : seulement si ouvert */}
                                    {openLibraries[nom] && (
                                        <div className="p-2 bg-gray-900">
                                            {bibliotheques[nom].length === 0 ? (
                                                <div className="border border-dashed border-gray-600 p-6 text-center text-gray-400">
                                                    Aucune image
                                                </div>
                                            ) : (
                                                <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3">
                                                    {[...bibliotheques[nom]]
                                                        .sort((a, b) =>
                                                            (a.title || "").localeCompare(
                                                                b.title || "",
                                                                "fr",
                                                                { sensitivity: "base" }
                                                            )
                                                        )
                                                        .map((img) => (
                                                            <div
                                                                key={img.id}
                                                                className={`relative p-2 rounded-2xl shadow transition cursor-pointer
${img.possede ? "border-4 border-green-500" : "border border-gray-200"}
${selectedImages.includes(String(img.id)) ? "ring-4 ring-cyan-500 scale-[1.03]" : ""}`}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    toggleSelect(String(img.id));
                                                                }}
                                                            >
                                                                {selectedImages.includes(String(img.id)) && (
                                                                    <span className="absolute top-1 left-1 bg-cyan-600 text-white text-xs px-2 py-0.5 rounded-full shadow">
                                                                        ✅
                                                                    </span>
                                                                )}
                                                                <div className="w-full h-16 flex items-center justify-center bg-gray-900">
                                                                    <img
                                                                        src={img.path}
                                                                        alt={img.title}
                                                                        className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                                                                    />
                                                                </div>
                                                                <div className="p-2 bg-gray-900/80">
                                                                    {img.editingTitle ? (
                                                                        <input
                                                                            type="text"
                                                                            value={img.title}
                                                                            onChange={(e) => {
                                                                                const newTitle = e.target.value;
                                                                                setBibliotheques((prev) => ({
                                                                                    ...prev,
                                                                                    [nom]: prev[nom].map((im) =>
                                                                                        im.id === img.id
                                                                                            ? { ...im, title: newTitle }
                                                                                            : im
                                                                                    ),
                                                                                }));
                                                                            }}
                                                                            onBlur={() =>
                                                                                toggleEditing(img.id, false)
                                                                            }
                                                                            onKeyDown={(e) =>
                                                                                e.key === "Enter" &&
                                                                                toggleEditing(img.id, false)
                                                                            }
                                                                            className="w-full text-center text-lg font-bold text-white bg-gray-800 rounded px-3 py-1 shadow-inner focus:outline-none focus:ring-2 focus:ring-cyan-500"
                                                                            autoFocus
                                                                        />
                                                                    ) : (
                                                                        <h3
                                                                            className="w-full text-center text-lg font-bold text-cyan-300 mt-2 cursor-pointer hover:underline"
                                                                            onClick={() => toggleEditing(img.id, true)}
                                                                        >
                                                                            {img.title || "Sans titre"}
                                                                        </h3>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </section>
                            ))
                        )}
                    </div>
                </div>
            )}




             

            



            {/* NAV */}
            <nav className="flex flex-wrap gap-2 mb-4">
                <button
                    onClick={() => setCurrentPage("library")}
                    className={`px-3 py-1 rounded ${currentPage === "library" ? "bg-cyan-500" : "bg-gray-700"
                        } font-semibold`}
                >
                    {`Bibliothèque (${images.filter((i) => i.possede).length} / ${images.length})`}
                </button>



                {Object.keys(pages)
                    .sort()
                    .map((p) => {
                        const total = pages[p].length;
                        const possede = pages[p].filter((i) => i.possede).length;
                        return (
                            <div key={p} className="flex items-center gap-1">
                                <button
                                    onClick={() => setCurrentPage(p)}
                                    className={`px-3 py-1 rounded ${currentPage === p ? "bg-cyan-500" : "bg-gray-700"
                                        } font-semibold`}
                                >
                                    {p} ({possede}/{total})
                                </button>
                                <button
                                    onClick={() => deletePage(p)}
                                    className="text-red-600 text-sm font-bold"
                                >
                                    ✕
                                </button>
                            </div>
                        );
                    })}




                <div className="relative">
                    <button
                        onClick={() => setMenuOpen(!menuOpen)}
                        className="p-2 rounded-full bg-cyan-500 text-white shadow-md hover:bg-cyan-400 transition-all"
                    >
                        ⚙️
                    </button>

                    {menuOpen && (
                        <div
                            className={`dropdown-panel absolute right-0 mt-2 w-56 z-50 ${menuOpen ? "animate-fadeIn" : "animate-fadeOut"
                                }`}
                        >
                            <button onClick={() => setFilterPossede("all")}>Tout afficher</button>
                            <button onClick={() => setFilterPossede("yes")}>Possédés ✅</button>
                            <button onClick={() => setFilterPossede("no")}>Non possédés ❌</button>
                        </div>
                    )}



                    <button
                        onClick={saveAllTitles}
                        className="px-3 py-1 rounded bg-blue-500 text-white font-semibold hover:bg-blue-400"
                    >
                        💾
                    </button>

                    

                </div>

                <div className="toolbar-compact">
                    <button onClick={selectAll} title="Tout sélectionner">✅</button>
                    <button onClick={deselectAll} title="Tout désélectionner">🚫</button>
                    <div className="relative inline-block">
                        <button
                            onClick={() => setMoveMenuOpen(!moveMenuOpen)}
                            title="Déplacer"
                            className="px-2 py-1 bg-yellow-500 rounded text-white"
                        >
                            📦 Déplacer
                        </button>

                        {moveMenuOpen && (
                            <div className="absolute top-full mt-1 right-0 w-40 bg-gray-800 text-white rounded shadow-lg z-50">
                                {/* Option bibliothèque principale */}
                                <button
                                    className="block w-full text-left px-3 py-1 hover:bg-gray-700"
                                    onClick={() => { moveSelected("library"); setMoveMenuOpen(false); }}
                                >
                                    Bibliothèque principale
                                </button>


                                {/* Options pages existantes */}
                                {Object.keys(pages)
                                    .filter(p => p !== currentPage)
                                    .map((p) => (
                                        <button
                                            key={p}
                                            className="block w-full text-left px-3 py-1 hover:bg-gray-700"
                                            onClick={() => { moveSelected(p); setMoveMenuOpen(false); }}
                                        >
                                            {p}
                                        </button>
                                    ))}
                            </div>
                        )}
                    </div>
                    <span className="count">{selectedImages.length}</span>
                </div>

                {Object.keys(bibliotheques).length > 0 && (
                    <select
                        onChange={(e) => {
                            moveSelectedToBibliotheque(e.target.value);
                            e.target.value = "";
                        }}
                        className="ml-2 px-2 py-1 bg-yellow-500 text-white rounded"
                    >
                        <option value="">→ Déplacer vers bibliothèque...</option>
                        {Object.keys(bibliotheques).map((nom) => (
                            <option key={nom} value={nom}>{nom}</option>
                        ))}
                    </select>
                )}

                {/* 🔍 Barre de recherche */}
                <div className="flex items-center gap-2 mb-2">
                    <input
                        type="text"
                        placeholder="🔍 Rechercher une image..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        className="flex-1 px-3 py-2 border rounded bg-gray-900 text-white"
                    />

                    {/* ✅ Compteur progression */}
                    <span className="px-3 py-2 bg-gray-800 text-white rounded text-sm">
                        {currentPage === "library"
                            ? `${images.filter((i) => i.possede).length} / ${images.length}`
                            : `${(pages[currentPage] || []).filter((i) => i.possede).length} / ${(pages[currentPage] || []).length}`}
                    </span>
                </div>

            
            </nav>

            {/* GRID */}
            <section>
                {filtered.length === 0 ? (
                    <div className="border border-dashed border-gray-600 p-6 text-center text-gray-400">
                        Aucune image
                    </div>
                ) : (
                    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3">
                            {[...filtered]
                                .sort((a, b) => (a.title || "").localeCompare(b.title || "", "fr", { sensitivity: "base" }))
                                .map((img) => (
                                    <div
                                        key={img.id}
                                        className={`relative p-2 rounded-2xl shadow transition cursor-pointer
    ${img.possede ? "border-4 border-green-500" : "border border-gray-200"}
    ${selectedImages.includes(String(img.id)) ? "ring-4 ring-cyan-500 scale-[1.03]" : ""}`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            const idStr = String(img.id);

                                            if (e.ctrlKey || e.metaKey) {
                                                // ✅ Sélection multiple (ajout / retrait)
                                                toggleSelect(idStr);
                                            } else if (e.shiftKey) {
                                                // 🧩 (optionnel) sélection d'une plage future
                                            } else {
                                                // ✅ Clic simple : bascule l'image (au lieu de tout remplacer)
                                                toggleSelect(idStr);
                                            }
                                        }}
                                    >
                                        {selectedImages.includes(String(img.id)) && (
                                            <span className="absolute top-1 left-1 bg-cyan-600 text-white text-xs px-2 py-0.5 rounded-full shadow">
                                                ✅
                                            </span>
                                        )}

                                        <div className="w-full h-16 flex items-center justify-center bg-gray-900">
                                            <img
                                                src={img.path}
                                                alt={img.title}
                                                className="max-h-full max-w-full object-contain transition-transform duration-300 hover:scale-110"
                                            />
                                        </div>




                                        <div className="p-2 bg-gray-900/80">
                                            {img.editingTitle ? (
                                                <input
                                                    type="text"
                                                    value={img.title}
                                                    onChange={(e) => {
                                                        const newTitle = e.target.value;
                                                        if (currentPage === "library") {
                                                            setImages(prev =>
                                                                prev.map(im =>
                                                                    im.id === img.id ? { ...im, title: newTitle } : im
                                                                )
                                                            );
                                                        } else {
                                                            setPages(prev => ({
                                                                ...prev,
                                                                [currentPage]: prev[currentPage].map(im =>
                                                                    im.id === img.id ? { ...im, title: newTitle } : im
                                                                ),
                                                            }));
                                                        }
                                                    }}
                                                    onBlur={() => toggleEditing(img.id, false)}
                                                    onKeyDown={(e) => e.key === "Enter" && toggleEditing(img.id, false)}
                                                    className="w-full text-center text-lg font-bold text-white bg-gray-800 rounded px-3 py-1 shadow-inner focus:outline-none focus:ring-2 focus:ring-cyan-500"
                                                    autoFocus
                                                />
                                            ) : (
                                                <h3
                                                    className="w-full text-center text-lg font-bold text-cyan-300 mt-2 cursor-pointer hover:underline"
                                                    onClick={() => toggleEditing(img.id, true)}
                                                >
                                                    {img.title || "Sans titre"}
                                                </h3>
                                            )}

                                        </div>

                                    


                                {/* Pages */}
                                

                                <div className="flex items-center justify-between">
                                    <label className="flex items-center space-x-1 text-sm">
                                        <input
                                            type="checkbox"
                                            checked={img.possede}
                                            onChange={() => togglePossede(img.id)}
                                        />
                                        <span>Possédé</span>
                                    </label>
                                </div>

                                {img.possede && (
                                    <span className="absolute top-1 right-1 bg-green-600 text-white text-xs px-2 py-0.5 rounded-full shadow">
                                        ✅
                                    </span>
                                )}

                                <select
                                    defaultValue=""
                                    onChange={(e) => {
                                        if (e.target.value) {
                                            moveImageToPage(img, e.target.value);
                                            e.target.value = "";
                                        }
                                    }}
                                    className="text-xs bg-gray-700 text-white rounded px-1 py-1 mt-1 w-full"
                                >
                                    <option value="">→ Déplacer vers...</option>
                                    {currentPage !== "library" && (
                                        <option value="library">Bibliothèque principale</option>
                                    )}
                                    {Object.keys(pages)
                                        .filter((p) => p !== currentPage)
                                        .map((p) => (
                                            <option key={p} value={p}>
                                                {p}
                                            </option>
                                        ))}
                                </select>

                                <button
                                    onClick={() =>
                                        removeImage(
                                            img.id,
                                            currentPage !== "library" ? currentPage : null
                                        )
                                    }
                                    className="glow"
                                    opacity= "20%"
                                    
                                >
                                    ❌ Supprimer
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </section>

            {/* MODAL */}
            {modal.open && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
                    onClick={() => setModal({ open: false, url: null })}
                >
                    <div
                        className="bg-gray-900 p-4 rounded-2xl max-w-3xl max-h-[90vh] overflow-auto"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex justify-between items-center mb-2">
                            <h3 className="font-bold text-cyan-400">Aperçu</h3>
                            <div className="flex gap-2">
                                <button
                                    onClick={() => downloadImage(modal.url)}
                                    className="bg-blue-600 px-2 py-1 rounded text-white hover:scale-105 transition-transform"
                                >
                                    📥 Télécharger
                                </button>
                                <button
                                    onClick={() => setModal({ open: false, url: null })}
                                    className="bg-gray-700 px-2 py-1 rounded hover:scale-105 transition-transform"
                                >
                                    Fermer
                                </button>
                            </div>
                        </div>
                        <img
                            src={modal.url}
                            alt="preview"
                            className="max-h-[70vh] object-contain rounded-lg animate-zoom"
                        />
                        <p className="text-xs mt-2 break-all text-gray-300">{modal.url}</p>
                    </div>
                </div>
            )}
        </div>
    );
}
